import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css'],
  standalone: true
})
export class LoaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
